export default "__VITE_ASSET__46878a9f__"